import React from "react";
import Layout from "@/components/layout";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import AboutOne from "@/components/about-one";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";

const AboutPage = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="Nosotros">
        <HeaderOne />
        <PageHeader title="Nosotros" name="Nosotros" />
        <AboutOne />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default AboutPage;
